<script>
import { Bar, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;
export default {
  name: "GraficoBarra",
  extends: Bar,
  mixins: [reactiveProp],
  props: ["chartData", "options", "estatisticaInfo"],
  mounted() {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options);
  }
};
</script>
